module.exports = __webpack_public_path__ + "static/media/StatementFeature1.e1e978ba.avif";